import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { SidebarClose } from 'lucide-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MovementsFilters } from './movementsFilters';

const FiltersTitleText = styled.div`
  color: ${({ theme }) => theme.colors.text.dark};
  font-weight: 600;
  line-height: 1.4;
  font-size: 16px;
`;

export const MovementsSidebar = ({ toggleFilters, filters, setFilters, filtersCount, showFilters }) => (
  <Box
    sx={{
      bg: 'neutral.0',
      width: '264px',
      transform: showFilters ? 'translateX(0%)' : 'translateX(-100%)',
      opacity: showFilters ? '1' : '0',
      transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
      flexShrink: 0,
      overflow: 'hidden',
      zIndex: 2,
      height: '100%',
    }}
  >
    <Box
      sx={{
        maxWidth: '264px',
        position: 'relative',
        borderRight: '1px solid',
        borderColor: 'border.subtle',
        height: '100%',
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width="24px"
        height="24px"
        color="neutral.400"
        sx={{ cursor: 'pointer', position: 'absolute', top: '4px', right: '12px', zIndex: 10 }}
        onClick={toggleFilters}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleFilters();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Close filters"
      >
        <Box as={SidebarClose} className="main-menu-item" width="16px" height="16px" flex="0 0 auto" />
      </Flex>
      <Flex flex="0 0 auto" flexDirection="column" sx={{ position: 'relative', height: '100%' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '8px 16px 16px 16px',
          }}
        >
          <FiltersTitleText data-testid="movements-filters-title">Filters</FiltersTitleText>
        </div>
        <MovementsFilters
          filters={filters}
          setFilters={setFilters}
          sx={{
            height: '100%',
            maxHeight: filtersCount > 0 ? 'calc(100vh - 160px)' : '100%',
            pb: '10px',
          }}
        />
      </Flex>
    </Box>
  </Box>
);

MovementsSidebar.propTypes = {
  toggleFilters: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  filtersCount: PropTypes.number,
  showFilters: PropTypes.bool,
};

MovementsSidebar.defaultProps = {
  filtersCount: 0,
  showFilters: false,
};
